import videojs from 'video.js';
import store from 'store';
import filter from 'lodash/filter';
const KEY = 'forceFallback';
const UNSUPPORTED_SOURCE_TYPES = 'unsupportedSourceTypes';
function load() {
    return store.get(UNSUPPORTED_SOURCE_TYPES) || [];
}
function save(sourceType) {
    const types = load();
    if (!types.includes(sourceType)) {
        types.push(sourceType);
        store.set(UNSUPPORTED_SOURCE_TYPES, types);
    }
}
function createFallback(options) {
    return function () {
        const error = this.error();
        if (error && error.code === 4) {
            const source = this.currentSource();
            const sources = this.currentSources();
            save(source.type);
            let i = 0;
            for (; i < sources.length; i++) {
                if (sources[i].src === source.src) {
                    break;
                }
            }
            if (sources.length > i) {
                this.src(sources[i + 1]);
                if (options.autoplay) {
                    this.play();
                }
            }
        }
    };
}
videojs.registerPlugin(KEY, function (options) {
    const fallback = createFallback(options);
    this.on('error', fallback);
    this.one('dispose', () => {
        this.off('error', fallback);
    });
    this.ready(() => {
        const currentSources = this.currentSources();
        const unsupportedSourceTypes = load();
        const srcs = filter(currentSources, ({ type }) => {
            return !unsupportedSourceTypes.includes(type);
        });
        if (currentSources.length !== srcs.length && srcs.length) {
            this.src(srcs);
        }
        setTimeout(() => {
            this.load();
        }, 1);
    });
});
export default KEY;
